import ApiResponse from "sr/models/ApiResponse";
import { post } from "sr/utils/axios";

export const reorderTasklist = async (tasks: { id: string }[]) => {
  return await post<ApiResponse<[]>>(
    `/customer/tasklist/reorder`,
    tasks as unknown as Record<string, unknown>
  ).then((res) => {
    try {
      if (res.success === true) {
        return res;
      } else {
        return null;
      }
    } catch (e) {}
  });
};
